/**
 * Where an applicant stands on one ad.
 *
 * Ordered as the hiring actually runs — a phone call, then a scheduled interview, then
 * the decision — so the row of buttons in Миний зар reads left to right as progress,
 * with the one negative outcome last on the right.
 *
 * Kept here rather than inline in the employer page because the jobseeker's
 * "Миний өргөдлүүд" shows the same states, and two copies of the labels would drift.
 */

export const APPLICANT_STATUSES = [
  {
    id: "called",
    label: "Утсаар ярьсан",
    /** Employer's button when active, and the chip a jobseeker sees. */
    bg: "#0EA5E9",
    chipBg: "#E0F2FE",
    chipText: "#0369A1",
  },
  {
    id: "scheduled",
    label: "Ярилцлага товолсон",
    bg: "#F59E0B",
    chipBg: "#FEF3C7",
    chipText: "#B45309",
  },
  {
    id: "accepted",
    label: "Тэнцсэн",
    bg: "#16A34A",
    chipBg: "#DCFCE7",
    chipText: "#15803D",
  },
  {
    id: "rejected",
    label: "Тэнцээгүй",
    bg: "#DC2626",
    chipBg: "#FEE2E2",
    chipText: "#B91C1C",
  },
];

const BY_ID = Object.fromEntries(APPLICANT_STATUSES.map((s) => [s.id, s]));

/**
 * Look up a status by id, tolerating whatever casing or naming the API sends.
 * Returns null for an unknown or absent value so callers can render nothing rather
 * than an empty chip.
 */
export const getApplicantStatus = (value) => {
  if (!value) return null;
  const key = String(value).trim().toLowerCase();
  if (BY_ID[key]) return BY_ID[key];

  // Server-side spellings for the same states. The first four are what a Diil employer's
  // own mark is stored as (see DiilEmployerConstants.ApplicantStatus) — the round trip
  // back to a label happens here, so the candidate reads "Тэнцсэн" rather than "hired".
  const aliases = {
    invited: "called",
    call: "called",
    phone_call: "called",
    contacted: "called",
    interview: "scheduled",
    interview_scheduled: "scheduled",
    booked: "scheduled",
    approved: "accepted",
    hired: "accepted",
    passed: "accepted",
    declined: "rejected",
    failed: "rejected",
  };
  return BY_ID[aliases[key]] || null;
};

export default APPLICANT_STATUSES;
